<template>
  <div>
    <div class="page-header">
      <div class="container-fluid">
        <h2 class="h5 no-margin-bottom">Yeni Servis</h2>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-12">
                  <div class="row">
                          <div class="col-lg-10 col-12 mt-1">
                            <label class="form-control-label">Ünvan</label>
                            <input disabled type="text" class="form-control" v-model="objeCihaz.unvan">
                          </div>
                          <div class="col-lg-2 col-12 mt-4 pt-3 px-0">
                            <button data-toggle="modal" data-backdrop="static" data-target=".bd-example-modal-lg" type="button" class="btn btn-primary submit bg-dark text-light w-100 d-block">Cihaz Listesi</button>                            
                          </div>
                          <div class="col-lg-12 col-12 mt-3">
                            <label class="form-control-label dashtext-1">Adres</label>
                            <input disabled type="text" class="form-control" v-model="adres">
                          </div>
                          <div class="col-lg-3 col-12 mt-3">
                            <label class="form-control-label">Anagrup</label>
                            <input disabled type="text" class="form-control" v-model="objeCihaz.anagrup">
                          </div>
                          <div class="col-lg-3 col-12 mt-3">
                            <label class="form-control-label">Altgrup</label>
                            <input disabled type="text" class="form-control" v-model="objeCihaz.altgrup">
                          </div>
                          <div class="col-lg-3 col-12 mt-3">
                            <label class="form-control-label dashtext-1">Barkod</label>
                            <input disabled type="text" class="form-control" :value="$helper.ilkharfBuyuk(objeCihaz.barkod)">
                          </div>
                          <div class="col-lg-3 col-12 mt-3">
                            <label class="form-control-label dashtext-1">Seri No</label>
                            <input disabled type="text" class="form-control" :value="$helper.ilkharfBuyuk(objeCihaz.serino)">
                          </div>

                  </div>
                    <div class="row mt-5">
                      <div class="col-12">
                        <div class="table-responsive"> 
                          <table class="table table-striped">
                              <tbody class="bg-dark">
                              <tr v-for="post in servis" :key="post.id">
                                <td>{{post.no}}</td>

                                <td>{{post.serino}}</td>
                                <td>{{post.model}}</td>
                                <td>{{$helper.trtgoster(post.tarih)}}</td>
                                <td class="dashtext-3">{{post.sn}}</td>
                              </tr>
                              </tbody>

                            </table>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                      <div class="row mb-3">
 <!-- @change="stchange($event)"-->
                        <div class="col-lg-6 col-12">
                        <label class="form-control-label dashtext-3">Servis Tipi *</label>
                          <select @change="onchange($event)"  v-model="newpost.st" class="form-control">
                            <option value="0">Servis Tipi Seç</option>
                            <option v-for="(option,index) in st" :value="option.id" :key="index">{{ option.alias }}
                            </option>
                          </select>
                        </div>

                        <div class="col-lg-6 col-12">
                          <label class="form-control-label">Sağlayıcı</label>
                            <select disabled  v-model="newpost.sa" class="form-control">
                              <option value="0">Sağlayıcı Yok</option>
                              <option v-for="(option,index) in salar" :value="option.id" :key="index">{{ option.alias }}</option>
                            </select>
                        </div>

                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-6 col-12">
                          <label class="form-control-label dashtext-3">Servis Nedeni ***</label>
                            <select v-model="newpost.sn" class="form-control">
                              <option value="0">Servis Nedeni Seç</option>
                              <option v-for="(option,index) in sn" :value="option.id" :key="index">{{ option.alias }}
                              </option>
                            </select>
                        </div>
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label dashtext-3">Servis Öncelik</label>
                            <select v-model="newpost.so" class="form-control">
                            <option value="0">Servis Öncelik Seç</option>
                            <option value="1">Düşük</option>
                            <option value="2">Orta</option>
                            <option value="3">Yüksek</option>
                            </select>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label">Çağrı Tarihi</label>
                            <input readonly type="text" class="form-control" v-model="newpost.ct">
                        </div>
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label">Çağrı Saati</label>
                            <input readonly type="time" class="form-control" v-model="newpost.cs">
                        </div>
                      </div>
                      
                      <div class="row mt-4 mb-3">
                        <div class="col-12">
                           <textarea style="height:100px" v-model="newpost.not" placeholder="Servis Notu" class="form-control" rows="10"></textarea>
                        </div>
                      </div>
                      <div class="row mt-3 mb-3">
                        <div class="col-lg-6 col-12">
                          <button @click="newpost.sd = 1; newpost.bolge = 20" class="btn btn-outline-danger w-100 btn-lg">Beklemede Kalsın</button>
                        </div>
                         <div class="col-lg-6 col-12">
                           <button @click="newpost.sd = 2" class="btn btn-outline-info btn-lg w-100">Hemen Yönlendir</button>
                         </div>
                      </div>
                      <div v-if="newpost.sd === 2" class="row mt-3 mb-3">

                        <div class="col-12">
                          <label class="form-control-label">Yönlendirilecek Bölge</label>
                            <select v-model="newpost.bolge" class="form-control">
                            <option v-for="(option,index) in bolge" :value="option.id" :key="index">{{ option.alias }}</option>
                            </select>
                        </div>
 
                      </div>
                      <div class="row mt-2">
                        <div class="col-12">
                           <button :disabled="progres.inprogres" @click="sendNewPost()" class="btn btn-danger d-block w-100 btn-lg">Servis Ekle</button>
                        </div>
                      </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
        <div class="modal fade bd-example-modal-lg " tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content bg-dark">
                  <div class="modal-body">
                    <div class="row mb-2 p-2">
                      <div class="col-10">
                          <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
                      </div>
                      <div class="col-2">
                        <button type="button" data-dismiss="modal" class="btn btn-outline-primary mt-1 d-block">Kapat</button>
                      </div>
                    </div>                    
                    <div class="row">
                    <div class="col-12">
                      <div class="table-responsive"> 
                      <table id="tablo" class="table table-striped">
                        <thead>
                          <tr>
                            <th>Anagrup</th>
                            <th>Model</th>
                            <th>Barkod</th>
                            <th>SeriNo</th>
                            <th>Durum</th>
                            <th>Lokasyon</th>
                            <th>Seç</th>

                          </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(post,index) in cihaz" :key="index">
                          <td>{{$helper.ilkharfBuyuk(post.cihazgrup)}}</td>
                          <td>{{$helper.ilkharfBuyuk(post.cihazaltgrup)}}</td>
                          <td class="dashtext-3">{{post.barkod}}</td>
                          <td>{{post.chz_serino}}</td>
                          <td class="dashtext-1">{{post.cd}}</td>
                          <td>{{$helper.ilkharfBuyuk(post.lokasyon)}}</td>
                          <td  class="text-center" v-if="$helper.sayfayetki(227916)"> 
                            <a href="javascript:void(0)" @click="itemClicked(post)"><i  class="fa fa-plus"></i> </a> 
                          </td>
                      </tr>
                      </tbody>
                </table>
                    </div>
                    </div>

                    </div>


                  </div> 

                </div>
              </div>
        </div>        


      </div>
    </section>
<!--{{item}}-->
<div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>

export default {
  name: 'demo',
  data () {
    return {
      program:this.$request.ayar().p, // local mi mikro api mi ? 
      search: '',
      carilist:false,
      currentTag: "All",
      kesif:false,
      montaj:false,
      itemsApi: [],
      item: {},
      items: [],
      posts:[],
      searchText:'',
      error:[],
      cihaz:[],
      servis:[],
      donem : this.$request.donem(),
      kid:this.$request.ayar().kid,
      ya:this.$request.ayar().ya,
      sn:[],
      st:[],
      so:[],
      salar:[],
      bolge:[],
      akod:'', // sn süzmek için cihazgrup kodunu aldık
      txt:'',
      objeCihaz:{
        unvan:'',
        anagrup:'',
        altgrup:'',
        barkod:'',
        serino:'',
      },
      newpost: {
        firma: this.$request.ayar().firmaid,
        id: '',
        sn: 0,
        st: 0,
        so: 0,
        sa: 0,
        sd:1, // beklemede mi yönlenmiş mi
        ct:this.$helper.getNow().tarih,
        cs:this.$helper.getNow().saat,
        not:'',
       // ckod:'',
        //cad:'',
        carid:0,
        servisno:'',
        bolge:0,
      },
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      source:this.$store.getters.getsource,
      adres:'' // servisinfo insert işleminden kaynaklı bunu dışarı aldık
  }    
  },
    created() {
     this.progres.inprogres = true
      this.yetki(this.sagetir,this.stf,this.sof)
      this.getcari();

    },
  computed: {

    // reversedMessage () {
    //   if(this.newpost.st!=0){
    //   if (this.newpost.st === 2){
    //    this.$request.get("servis/sngetir/"+this.akod)
    //     .then(res=> {this.sn = res.results})
    //   }
    //   else{

    //     this.$request.get("servis/sngetir2/"+this.newpost.st+'/'+this.newpost.firma)
    //     .then(res => {
    //       this.sn = res.results;
    //       console.log(res.results)
    //       if (this.newpost.st!=2){this.newpost.sn = res.results[0].id }
    //       else{
    //         //this.newpost.sn=0
    //         }
    //     })
    //     .catch(err => this.error.push(err))
        
    //   }
    //   }
    //   return this.sn
    // }
  }, 
  methods: {
    yetki : function(sa,st,so){ 
          if (this.$helper.sayfayetki(610696)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                this.txt="where k.kid_ ="+this.kid //sagetir için
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
                this.txt="where s.firma ="+this.newpost.firma //sagetir için
            }
                if(islem){this.sagetir()}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
          sa();
          st();
          so();
          //this.itemSelected();
    },
    getcari(){
      this.$store.dispatch('cari_getir', {req:this.$request,data:this.$route.params.guid}).then(cari=>{
        //console.log(cari)
        this.newpost.carid = this.$route.params.guid;
        this.objeCihaz.unvan = cari.data[0].unvan;
        this.adres = cari.data[0].adres;
        this.getcihaz(); //cari cihazları
        console.log("getcari")
      })

    },
    getcihaz(){ //cari cihaz listesi
      var data = "'" + this.$route.params.guid + "'"
      this.$request.post("servis/api", { q: 'cihaz_list',isim:this.$request.ayar().f1, where: { alan: 'adr.adr_Guid =', value: data, status: true } })
        .then(cihaz => {
           this.cihaz = cihaz.data
           this.itemSelected()
           this.progres.inprogres = false
         })
    },

    itemSelected () { // cari id ye göre cihaz geçmişi
      this.$request.get("servis/detay/cari/"+this.$route.params.guid+'/'+this.donem)
      .then(res => {
        this.$store.dispatch('view_servis',{data:res.results,req:this.$request}).then(sonuc=>{
          this.servis = sonuc.sort((t1,t2) => t1.id > t2.id ? -1 : 1)
          this.progres.inprogres = false
       })
      })
      .catch(err => {
        this.error.push(err)
        this.progres.inprogres = false

      })

    },    
    itemClicked (item) {
      this.akod = item.anakod;
      this.newpost.id = item.cihazid;
      this.objeCihaz.anagrup = item.cihazgrup;
      this.objeCihaz.altgrup = item.cihazaltgrup;
      this.objeCihaz.barkod = item.barkod;
      this.objeCihaz.serino = item.chz_serino;
      console.log(this.objeCihaz)

    },
    onchange(event){
      if (this.newpost.st === 2){
       this.$request.get("servis/sngetir/"+this.akod)
        .then(res=> {this.sn = res.results})
      }
      else{

        this.$request.get("servis/sngetir2/"+event.target.value+'/'+this.newpost.firma)
        .then(res => {
          this.sn = res.results;
        })
        .catch(err => this.error.push(err))
        
      }
    },  
    sagetir(){
          this.$request.get("servis/sagetir/"+this.txt)
          .then(res => {
            if (res.status === 200){this.salar = res.results}
            else{this.sa.push({"id" : 0,"alias" : "Sağlayıcı yok"})}
          })
          .catch(err => this.error.push(err))
    },

    sendNewPost(){
      if (this.newpost.st!=0 && this.newpost.sd!=0 && this.newpost.so!=0 && this.newpost.sn!=0 && this.newpost.carid) {
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Servisi Eklenecek...',
              icon: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    this.progres.inprogres = true;
                    this.progres.mesaj = 'Bekleyiniz...';
                    this.$request.get("servis/serviscount/"+this.newpost.firma+"/"+this.donem)
                      .then(res => {
                        if (res.status === 200) 
                        {
                          this.newpost.servisno = res.results[0].adet
                          this.sendNewPost2()
                        }
                      })
                      //.catch(err)
                  }
                })
     }
     else{
       this.$swal("Girdileri Kontrol Et")
     } 
     },
    sendNewPost2(){
      console.log(this.newpost)
      this.$request.post("servis/servis/",{s:this.newpost,c:this.objeCihaz,p:this.program})
      .then(res => {
        
        let log = {
          servis_id : res.data.id,
          tarih:res.data.tarih,
          saat : res.data.saat,
          sd:res.data.sd,
          kid:this.kid,
          islem: 'Servis Eklendi'
        }
          this.$request.post("servis/servis_log/",log)
            .then(res => {
                //this.progres.inprogres = true;
                this.progres.mesaj = 'Log Kaydı Yapıldı...';
               this.$swal('İşlem Başarılı', 'Servis Başarı ile açıldı', 'success')
            })
            this.progres.inprogres = false;
            this.progres.mesaj = 'Servis Eklendi...';
      })
      .catch(err => {this.error.push(err)
            this.progres.inprogres = false;
            this.progres.mesaj = 'Tekrar Deneyin...';
      })
    },



    // stchange(event){
    //   this.progres.inprogres = true
    //   if (this.$route.params.guid==0) {
    //     this.$swal("Sadece Keşif")
    //     this.newpost.st =  3;
    //   }
    //   if (event.target.value==4) {
    //     this.newpost.st =  4;
    //     this.montaj =  true;

    //   }
    //   if (event.target.value==3) {
    //     this.newpost.st = 3;
    //     this.kesif = true;

    //   }
    //   this.progres.inprogres = false
    //   console.log(this.newpost)


    // },

    sttip(){ // burada pasif
      this.newpost.sn = 0;

        this.posts=this.$store.getters.getsource;
        this.progres.inprogres = false
        this.carilist = true


    },

    stf(){
      this.$request.get("servis/stgetir/"+this.newpost.firma)
      .then(
        res => {
          this.st = res.results;
          console.log(this.st)
          this.sof('so');
      })
      .catch(err => this.error.push(err))
    },

    sof(tip){
      this.$request.get("servis/define/"+this.newpost.firma+"/so")
      .then(res => {this.so = res.results
      this.bolgegetir()
      })
      .catch(err => this.error.psuh(err))
       
    },
    bolgegetir(){
      this.$request.get("servis/bolge/"+this.newpost.firma)
      .then(res => {
        this.bolge = res.results
      })
    },
    filter: function(tag) {
          this.currentTag = tag;
    },
    filteredItems: function(array,field) {
        var filter = this.currentTag;
        if (filter == 'All' ){
            return array
        }
        else{
              return array.filter(function(item) {
              return item[field].indexOf(filter) !== -1;
          });
        }
    }
  },
  // watch: {
  //   akod(val){
  //     this.fullName = val + ' ' + this.lastName
  //   },
  // },
}
</script>
<style scoped>
#arama{height: calc(2.4rem + 45px) !important;font-size: 56px !important; border-radius:0%;}

.form-control{height: calc(2.4rem + 15px);font-size: 16px; border-radius:0%;}
</style>


// WEBPACK FOOTER //
// src/views/servis/createcariden.vue